module.exports = __webpack_public_path__ + "static/media/logo-domingosmourao.b7bb6828.png";